export default {
  get: {
    USER_DATA: 'GET_USER_DATA',
    SHARED_CONTENTS: 'GET_SHARED_CONTENTS'
  },
  post: {
    USER_DATA: 'POST_USER_DATA',
    SHARED_CONTENTS: 'POST_SHARED_CONTENTS'
  }
}



// WEBPACK FOOTER //
// ./src/store/action-types.js